import { api } from '@/shared/lib/api';
import type { Notification, NotificationStats, NotificationFilters } from '../types';

interface ApiResponse<T> {
  data: T;
  timestamp: string;
}

interface PaginatedResponse<T> {
  data: T;
  pagination: {
    total: number;
    limit: number;
    offset: number;
    hasMore: boolean;
  };
  timestamp: string;
}

export const notificationsAPI = {
  /**
   * Listar notificações do usuário
   */
  list: (filters?: NotificationFilters) => {
    const params = new URLSearchParams();
    if (filters?.isRead !== undefined) params.append('isRead', String(filters.isRead));
    if (filters?.type) params.append('type', filters.type);
    if (filters?.priority) params.append('priority', filters.priority);
    if (filters?.limit) params.append('limit', String(filters.limit));
    if (filters?.offset) params.append('offset', String(filters.offset));

    return api.get<PaginatedResponse<Notification[]>>(
      `/notifications${params.toString() ? `?${params.toString()}` : ''}`
    );
  },

  /**
   * Obter contagem de notificações não lidas
   */
  getUnreadCount: () => api.get<ApiResponse<{ count: number }>>('/notifications/unread-count'),

  /**
   * Obter estatísticas de notificações
   */
  getStats: () => api.get<ApiResponse<NotificationStats>>('/notifications/stats'),

  /**
   * Marcar notificação como lida
   */
  markAsRead: (id: string) => api.patch<ApiResponse<Notification>>(`/notifications/${id}/read`),

  /**
   * Marcar todas as notificações como lidas
   */
  markAllAsRead: () =>
    api.patch<ApiResponse<{ count: number; message: string }>>('/notifications/read-all'),

  /**
   * Deletar notificação
   */
  delete: (id: string) => api.delete(`/notifications/${id}`),

  /**
   * Deletar todas as notificações
   */
  deleteAll: () => api.delete<ApiResponse<{ count: number; message: string }>>('/notifications'),
};
